import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  min-height: 100vh;
  color: ${({ theme }) => theme.colors.text};

  display: flex;
  align-items: stretch;
`;
